import { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { Clock } from 'lucide-react';
import Employees from './timeclock/Employees';
import Records from './timeclock/Records';
import Vacations from './timeclock/Vacations';
import Reports from './timeclock/Reports';
import TCSettings from './timeclock/TCSettings';

export default function TimeClock() {
  const [tab, setTab] = useState('records');
  return (
    <div data-testid="timeclock-page">
      <div className="flex items-center gap-3 mb-6">
        <Clock className="w-6 h-6 text-[#1D3C6E]" />
        <h1 className="text-2xl font-bold text-[#1D3C6E] font-['Outfit']">Checador</h1>
      </div>
      <Tabs value={tab} onValueChange={setTab} className="w-full">
        <TabsList className="mb-4 flex flex-wrap">
          <TabsTrigger value="records" data-testid="tc-tab-records">Registros</TabsTrigger>
          <TabsTrigger value="employees" data-testid="tc-tab-employees">Empleados</TabsTrigger>
          <TabsTrigger value="vacations" data-testid="tc-tab-vacations">Vacaciones</TabsTrigger>
          <TabsTrigger value="reports" data-testid="tc-tab-reports">Reportes</TabsTrigger>
          <TabsTrigger value="settings" data-testid="tc-tab-settings">Configuracion</TabsTrigger>
        </TabsList>
        <TabsContent value="records"><Records /></TabsContent>
        <TabsContent value="employees"><Employees /></TabsContent>
        <TabsContent value="vacations"><Vacations /></TabsContent>
        <TabsContent value="reports"><Reports /></TabsContent>
        <TabsContent value="settings"><TCSettings /></TabsContent>
      </Tabs>
    </div>
  );
}
